<template>
	<el-dialog
		class="modal-select-access"
		:title="title"
		:visible.sync="visible"
		@close="$_cancle"
		lock-scroll
		append-to-body
		:close-on-click-modal="false"
		:close-on-press-escape="false"
	>
		<div class="content">
			<div class="filter-box">
        <el-input v-model="filter.brandName" placeholder="品牌名称" style="width: 148px; margin-right: 10px"></el-input>
				<el-input
					v-model="filter.accessName"
          v-if="showBrandName"
					placeholder="请输入供应商订阅名称"
					style="width: 148px; margin-right: 10px"
				></el-input>
				<el-input
					v-model="filter.accessKey"
					placeholder="请输入AccessKey"
					style="width: 148px; margin: 0 10px"
				></el-input>
				<el-button @click="$_search" class="search__btn">查询</el-button>
				<el-button @click="$_reset" class="reset__btn">重置</el-button>
			</div>
			<!-- 数据列表 -->
			<el-table
				class="table-list__box"
				ref="accessesTable"
				v-loading="isLoading"
				:data="dataList"
				height="296"
				highlight-current-row
				@current-change="$_changeSelected"
				stripe
				tooltip-effect="dark"
			>
				<el-table-column width="50">
					<template slot-scope="scope">
						<el-radio :label="scope.row.accessKey" :value="accessKey">
							<span></span>
						</el-radio>
					</template>
				</el-table-column>

				<el-table-column
					v-for="column in columns"
					:key="column.key"
					:prop="column.key"
					:label="column.label"
					:width="column.width"
					:resizable="false"
					show-overflow-tooltip
				></el-table-column>

				<div class="table-list__empty small" slot="empty"></div>
			</el-table>
		</div>

		<div slot="footer" class="dialog-footer">
			<el-button class="save__btn" @click="$_submit">保存</el-button>
			<el-button class="cancel__btn" @click="$_cancle">取消</el-button>
		</div>
	</el-dialog>
</template>
<script>
const columns = [
	{ key: 'accessName', label: '供应商订阅名称' },
	{ key: 'accessKey', label: 'AccessKey', width: 160 }
]
export default {
	name: 'modal-select-access',
	props: {
		title: { type: String, default: '' },
		selected: { type: String, default: '' },
		accessList: { type: Array, default: () => [] },
		showBrandName: { type: Boolean, default: false }
	},
	data() {
		return {
			visible: false,
			isLoading: false,
			filter: {
        brandName: '',
				accessName: '',
				accessKey: ''
			},
			columns,
			dataList: [],
			accessKey: ''
		}
	},
	methods: {
		$_reset() {
			this.filter.brandName = ''
			this.filter.accessName = ''
			this.filter.accessKey = ''
			this.$_search()
		},
		$_search() {
			this.dataList = this.accessList.filter(item => {
				return (
          ~item.brandName.indexOf(this.filter.brandName) &&
					~item.accessName.indexOf(this.filter.accessName) &&
					~item.accessKey.indexOf(this.filter.accessKey)
				)
			})
		},
		// 选中行变化
		$_changeSelected(row) {
			if (row) {
				this.accessKey = row.accessKey
			} else {
				this.accessKey = ''
			}
		},
		// 保存
		$_submit() {
			if (this.accessKey !== '') {
				let access = this.accessList.find(
					item => item.accessKey === this.accessKey
				)
				this.$emit('callback', access)
				this.$_cancle()
			} else {
				$MessageBox.alert({ content: '请选择相应供应商订阅信息' })
			}
		},
		// 取消
		$_cancle() {
			this.visible = false
			this.$emit('close')
		}
	},
	created() {
		this.dataList = this.accessList.concat([])
		if (this.selected) {
			this.accessKey = this.selected
		}
		if (this.showBrandName) {
			this.columns = [
				{ key: 'brandName', label: '品牌名称', width: 160 },
				{ key: 'accessName', label: '供应商订阅名称' },
				{ key: 'accessKey', label: 'AccessKey', width: 160 }
			]
		}
	},
	mounted() {
		this.visible = true
	}
}
</script>

<style lang="scss" scoped>
.content {
	padding: 10px 30px 15px;
}
.filter-box {
	position: relative;
	height: 60px;
	border: 1px solid #eee;
	background-color: #f5f6f7;
	padding: 0 14px;
	display: flex;
	justify-content: left;
	align-items: center;
	.autocomplete-box {
		display: inline-block;
		position: relative;

		.autocomplete-empty {
			padding: 10px;
			margin: 0;
			color: #535353;
			top: 33px;
			width: 100%;
		}
	}
}
.table-list__box {
	border: 1px solid #eee;
	margin-top: -1px;
	background-color: #f9f9f9;
}
</style>
